(function (window) {

    if ($('.site-header').length <= 0) {
        return;
    };

    var globalNav = function () {
        var menuStack = [];
        var ui = {};
        var isMobile;
        var SHOW_CSS = '-active';
        var NO_SCROLL = 'noscroll';
        var MEDIA_QUERY = '(max-width: 991px)';
        var mql = window.matchMedia(MEDIA_QUERY);


        function cacheUI() {
            ui.$body = $('body');
            ui.$nav = $('[data-region="main-nav"]');
            ui.$globalNav = $('[data-region="globalnav"]');
            ui.$globalnavtrigger = $('[data-control="globalnavtrigger"]');
            ui.$closeBtn = $('[data-control="closeGlobalNav"]');
            ui.$backBtn = $('[data-control="back"]');
        }

        function toggleGlobalNav(e) {
            e.preventDefault();
            e.stopPropagation();
            ui.$body.addClass(NO_SCROLL);
            ui.$globalNav.addClass(SHOW_CSS);
            $("body").on('click', function (event) {
                checkGlobalNavOpen(event); 
              });
        }

        function checkGlobalNavOpen (event) {
            if(!ui.$body.hasClass(NO_SCROLL)) {
                return;
            }
            if (!$(event.target).parents('[data-region="globalnav"]').length) {
                hideGlobalNav()
            }
        }


        function hideGlobalNav() {
            ui.$globalNav.removeClass(SHOW_CSS);
            ui.$body.removeClass(NO_SCROLL);
            $("body").off('click', function (event) {
                checkGlobalNavOpen(event); 
              });
        }


        function handleMediaQueryChange(mql) {
            hideGlobalNav();
        } 

        function bindEvents() {
            ui.$globalnavtrigger.on('click', toggleGlobalNav);
            ui.$closeBtn.on('click', hideGlobalNav);
        }

        function init() {
            cacheUI();
                bindEvents();
                handleMediaQueryChange(mql);
        }

        return {
            init: init
        };
    };

    var globalNav = globalNav();
    globalNav.init();
})(window);
